// Use the shared Facade singleton from the framework package so that
// internal framework modules (ModulesManager, etc.) and game code operate
// on the exact same object reference.
import { Facade } from '@dragonframework/modules'
import { IS_DEBUG_BUILD } from '@/utils/RuntimeEnv'

// Extend with game-specific defaults (all typed through @/modules IFacade)
Object.assign(Facade, {
    gameVersion: '1.0.0',
    gameId: '1429',
    bonusGameId: '1386005',
    isDebug: IS_DEBUG_BUILD,
    isQuickSpin: false,
    isTurboSpin: false,
    isAuto: false,
    requestOngoing: false,

    displayConfig: null,
    symbolAnimationsConfig: null,
    reelsConfig: null,
    anticipationConfig: null,
    symbolsConfig: null,
    winningsConfig: null,
    defaultConfig: null,

    renderer: null,
    resizer: null,
    orientation: null,
    container: null,

    urlParams: null,
    payouts: null,
    model: null,
    status: null,
    currentState: null,
    isPopupBlockingInput: false,
    /** Pixi Buy Bonus popup visible — Space/spin must not start a round. */
    isBuyBonusPopupOpen: false,
    /** FS jackpot / commendation / upgrade popups — freeze newly started HV/MV idles. */
    pauseHighPayIdleForFsPopup: false,
    pendingImmediateStopRequested: false,
    reelsStates: null,
    _showTournament: false,
    _showTournamentBadge: false,
})

export default Facade
